export default __webpack_public_path__ + "static/media/texp2.da6b8c91.png";